/* ==========================================================================
   CUBS — Automatic cart upsells

   Fills the slots the Liquid sources left empty using Shopify's
   Recommendations API. Anything already in the cart or already rendered is
   dropped before insertion, so the rail never repeats a product.
   ========================================================================== */
(() => {
  if (window.__cubsCartInit) return;
  window.__cubsCartInit = true;

  const ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  const hydrate = async (track) => {
    if (track.dataset.cubsAutoDone === '1') return;
    track.dataset.cubsAutoDone = '1';

    const productId = track.dataset.cubsAutoProduct;
    const limit = Number(track.dataset.cubsAutoLimit) || 0;
    if (!productId || limit <= 0) return;

    // Handles the Liquid pass already used, as a "|a|b|c|" fence.
    const excluded = new Set(
      (track.dataset.cubsAutoExclude || '')
        .split('|')
        .map((handle) => handle.trim())
        .filter(Boolean)
    );

    const url =
      `${ROOT}recommendations/products` +
      `?section_id=${encodeURIComponent(track.dataset.cubsAutoSection)}` +
      `&product_id=${encodeURIComponent(productId)}` +
      `&limit=${Math.min(limit + excluded.size, 10)}` +
      `&intent=related`;

    let markup;
    try {
      const response = await fetch(url);
      if (!response.ok) return;
      markup = await response.text();
    } catch (error) {
      return;
    }

    const parsed = new DOMParser().parseFromString(markup, 'text/html');
    const cards = Array.from(parsed.querySelectorAll('[data-cubs-handle]'));

    let added = 0;
    for (const card of cards) {
      if (added >= limit) break;

      const handle = card.dataset.cubsHandle;
      if (!handle || excluded.has(handle)) continue;
      if (track.querySelector(`[data-cubs-handle="${CSS.escape(handle)}"]`)) continue;

      excluded.add(handle);
      track.appendChild(document.importNode(card, true));
      added += 1;
    }

    if (added > 0) {
      // Let the shared scroller controller re-evaluate its arrow states.
      track.dispatchEvent(new Event('scroll', { bubbles: true }));
    }
  };

  const scan = () => {
    document.querySelectorAll('[data-cubs-auto-upsell]').forEach(hydrate);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scan, { once: true });
  } else {
    scan();
  }

  // The cart drawer re-renders on every cart change — rescan the fresh markup.
  let queued = false;
  new MutationObserver(() => {
    if (queued) return;
    queued = true;
    requestAnimationFrame(() => {
      queued = false;
      scan();
    });
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
